<template>
  <b-container fluid>
    <backlink />
    <h1>Barème transport</h1>

    <ChronopostSetting />

    <div class="transport-rate-heading mt-4">
      <h2 class="h4">Grille messagerie (poids × distance)</h2>
      <b-form-radio-group
        v-model="view"
        buttons
        button-variant="outline-primary"
        size="sm"
        class="transport-rate-heading__views"
      >
        <b-form-radio value="grid">
          <i class="far fa-th"></i>
          Grille
        </b-form-radio>
        <b-form-radio value="list">
          <i class="far fa-list"></i>
          Liste
        </b-form-radio>
      </b-form-radio-group>
    </div>

    <p class="text-muted">
      Prix <strong>par trajet</strong> appliqué au-delà du seuil Chronopost : il est compté une
      fois à l'aller et une fois au retour, sauf si le client retire au comptoir ou dépose le
      matériel à l'entrepôt.<br />
      On retient la première zone dont la borne « km max » couvre la distance, et le premier
      palier dont la borne « poids max » couvre le poids de l'article.
    </p>

    <TransportRateGrid v-if="view === 'grid'" />
    <AdminTable v-else :config="config"></AdminTable>
  </b-container>
</template>

<script>
import AdminTable from "@/components/Global/AdminTable";
import ChronopostSetting from "./ChronopostSetting";
import TransportRateGrid from "./TransportRateGrid";
import config from "./config";

const VIEW_STORAGE_KEY = "transport_rate_view";

export default {
  name: "TransportRateList",
  components: {
    AdminTable,
    ChronopostSetting,
    TransportRateGrid,
  },
  data() {
    return {
      config: config,
      // La grille reprend la présentation du barème client : c'est la vue par défaut.
      // Le choix est mémorisé pour ne pas être à refaire à chaque visite.
      view: localStorage.getItem(VIEW_STORAGE_KEY) || "grid",
    };
  },
  watch: {
    view(value) {
      localStorage.setItem(VIEW_STORAGE_KEY, value);
    },
  },
};
</script>

<style lang="scss" scoped>
.transport-rate-heading {
  display: flex;
  align-items: center;
  justify-content: space-between;
  flex-wrap: wrap;

  h2 {
    margin-bottom: 0;
  }

  &__views i {
    margin-right: 4px;
  }
}
</style>

<!--
  Les boutons de bascule sont rendus par bootstrap-vue à l'intérieur du composant :
  les styles scopés ne les atteignent pas. Ce bloc non scopé reste circonscrit à la
  classe `.transport-rate-heading__views`, propre à cet écran.
-->
<style lang="scss">
.transport-rate-heading__views {
  // Le thème impose height/line-height: 40px aux .btn ; le libellé (label wrappant
  // l'input radio) ne se centre pas verticalement. Flex le recentre proprement.
  .btn {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    line-height: 1;
    margin-bottom: 0;
  }

  // Hors d'un .form-group, l'état actif de outline-primary retombe sur le bleu
  // Bootstrap par défaut : on force la couleur primaire du thème (vert).
  .btn-outline-primary:not(:disabled):not(.disabled).active,
  .btn-outline-primary:not(:disabled):not(.disabled):active,
  .btn-outline-primary:not(:disabled):not(.disabled).focus,
  .btn-outline-primary:not(:disabled):not(.disabled):focus {
    background-color: #1aae7c;
    border-color: #1aae7c;
    color: #fff;
    box-shadow: none;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/TransportRate/TransportRateList.vue